import { useEffect, useState } from "react";
import validator from "validator";

const useValidate = (input) => {
  // eslint-disable-next-line
  const [isValid, setIsValid] = useState(null);
  const [error, setError] = useState("");
  const { type, value, required, focused, match, id, readonly } = input;

  useEffect(() => {
    if (focused) {
      if (required) {
        if (validator.isEmpty(value)) {
          setIsValid(false);
          setError("Field is required");
          return;
        } else {
          setIsValid(true);
          setError("");
        }
      }

      if (type === "email") {
        // eslint-disable-next-line
        if (validator.isEmail(value)) {
          setIsValid(true);
          setError("");
          return;
        } else {
          setIsValid(false);
          setError("Not a valid email address");
        }
      }
      if (type === "tel") {
        if (validator.isMobilePhone(value)) {
          setIsValid(true);
          setError("");
        } else {
          setIsValid(false);
          setError("Not a valid phone number");
        }
      }

      if (id) {
        if (
          validator.matches(
            value,
            /([a-z].*[A-Z])|([A-Z].*[a-z])/ && /([!,%,&,@,#,$,^,*,?,_,~])/
          ) &&
          validator.isLength(value, { min: 8 })
        ) {
          setIsValid(true);
          setError("");
          return;
        } else {
          setIsValid(false);
          setError(
            "At least 8 characters with uppercase, lowercase, and special character"
          );
        }
      }

      if (match) {
        if (validator.equals(value, match)) {
          setError("");
        } else {
          setError("Password do not match");
        }
      }

      if (readonly) {
        if (validator.isLength(value, { min: 1 })) setError("");
      }
    }
  }, [type, value, required, focused, match, id, readonly]);
  return [isValid, error];
};

export default useValidate;
